import AppErrorsBlock from './AppErrorsBlock.vue';

export default AppErrorsBlock;



// WEBPACK FOOTER //
// ./src/uikit/components/AppErrorsBlock/index.ts